"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusBuyPopUpContent = void 0;
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const NolimitPromotionPlugin_1 = require("../../NolimitPromotionPlugin");
const Label_1 = require("@nolimitcity/slot-launcher/bin/gui/labels/Label");
const CurrencyUtils_1 = require("../../utils/CurrencyUtils");
const PromoPanelTextStyles_1 = require("../../config/PromoPanelTextStyles");
const PromoPanelLabelIDs_1 = require("../../enums/PromoPanelLabelIDs");
/**
 * Created by jonas on 2023-11-01.
 */
class BonusBuyPopUpContent extends PIXI.Container {
    constructor(featureData) {
        super();
        this.featureName = featureData.name;
        this.featureImage = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(featureData.name));
        this.featureImage.anchor.set(0.5, 0.5);
        this.bet = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
        this.price = (+this.bet * featureData.price);
        this.priceString = CurrencyUtils_1.CurrencyUtils.formatWithDecimalCutOff(this.price);
        this.priceLabel = new Label_1.Label(this.priceString, PromoPanelTextStyles_1.PromoPanelTextStyles.POP_UP_FORMATTED_PRICE);
        this.priceLabel.anchor.set(0.5, 0.5);
        this.textLabel = new Label_1.Label(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.CHARGE_FROM_WALLET), PromoPanelTextStyles_1.PromoPanelTextStyles.POP_UP_CHARGE_FROM_WALLET_TEXT);
        this.textLabel.anchor.set(0.5, 0.5);
        this.featureImage.position.set(0, 150);
        this.priceLabel.position.set(0, 340);
        this.textLabel.position.set(0, 380);
        this.addChild(this.featureImage, this.priceLabel, this.textLabel);
    }
}
exports.BonusBuyPopUpContent = BonusBuyPopUpContent;
//# sourceMappingURL=BonusBuyPopUpContent.js.map